var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarMatches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6667C9.33333 10.6667 10.6667 9.66667 10.6667 8C10.6667 6.33333 9.33333 5.33333 8 5.33333M8 10.6667C6.66667 10.6667 5.33333 9.66667 5.33333 8C5.33333 6.33333 6.66667 5.33333 8 5.33333M8 10.6667L8 5.33333M8 10.6667L8 14M8 5.33333V2M8 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.403 2.59695 14 3.33333 14H8M8 2H12.6667C13.403 2 14 2.59695 14 3.33333V12.6667C14 13.403 13.403 14 12.6667 14H8",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMatches);
export default __webpack_public_path__ + "static/media/sidebar-matches.95b0744b23c267e6c71ba0823dad28ad.svg";
export { ForwardRef as ReactComponent };